// extracted by mini-css-extract-plugin
export default {"root":"_17c-p","label":"_2oDES"};